export default "__VITE_ASSET__Da7R1BEz__"